export default "__VITE_ASSET__Clh2JfQx__"